module.exports = __webpack_public_path__ + "static/media/thumbnail_awards_2022.d7d8faa4.png";